export default __webpack_public_path__ + "static/media/notfound.eb29bfd9.png";